import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { REGISTER_URL } from '../lib/authLinks';

const ConfidenceSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="section-premium flex items-center justify-center">
      {/* Premium Background with overlay */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-yellow-900/10 via-transparent to-transparent"></div>
        {/* Premium Overlay pattern */}
        <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: 'radial-gradient(circle, #eab308 2px, transparent 2px)',
          backgroundSize: '60px 60px'
        }}></div>
      </div>

      {/* Radial glow */}
      <div className="absolute inset-0 opacity-20" style={{
        background: 'radial-gradient(circle at 30% 50%, rgba(234, 179, 8, 0.15) 0%, transparent 50%)'
      }}></div>

      <div className={`relative z-10 max-w-7xl mx-auto px-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left side - Design 16 */}
          <div className="relative animate-fade-in-left">
            {/* Glow effect behind image */}
            <div className="absolute -inset-4 bg-yellow-500/10 blur-3xl rounded-3xl animate-pulse"></div>
            
            <div className="relative w-full max-w-[420px] mx-auto rounded-3xl overflow-hidden border-2 border-yellow-500/30 shadow-2xl shadow-yellow-500/20 bg-gradient-to-br from-gray-900 via-black to-gray-900 hover-lift">
              <img 
                src="/images/Design 16.png" 
                alt="Design 16" 
                className="w-full h-auto object-contain"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right side - Content */}
          <div className="space-y-10 text-center md:text-left animate-fade-in-right animate-delay-200">
            <h2 className="text-premium-subheading leading-tight animate-fade-in-up">
              Build confidence
              <br />
              <span className="gradient-gold-text">with fully automated trading</span>
            </h2>
            
            <p className="text-gray-300 text-xl max-w-xl animate-fade-in-up animate-delay-300 leading-relaxed font-light">
              PreciseFx's AI analyzes market trends, manages risk, and executes trades automatically in Forex & Stock Markets — no manual charts or experience required.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-6 animate-fade-in-up animate-delay-400">
              <a href={REGISTER_URL} target="_blank" rel="noopener noreferrer">
                <Button className="btn-premium text-xl px-10 py-7">
                  Start with $100
                </Button>
              </a>
              <Link to="/trading/how-to-trade" className="gradient-gold-text hover:text-yellow-400 flex items-center space-x-2 text-xl transition-all duration-300 group font-medium">
                <span>Learn more</span>
                <span className="transform group-hover:translate-x-2 transition-transform">›</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConfidenceSection;
